export default "__VITE_ASSET__CeqrnLc1__"